import { Button, Modal } from '../../../components/ui';

/**
 * Confirmacao de exclusao. O botao vermelho (`danger`) fica reservado para
 * esta acao, e o texto diz O QUE vai ser apagado -- "Tem certeza?" sozinho
 * nao ajuda quem clicou na lixeira errada.
 */
export function ModalConfirmarExclusao({ alvo, onCancel, onConfirm }: { readonly alvo: string | null; readonly onCancel: () => void; readonly onConfirm: () => void }): JSX.Element | null {
  return (
    <Modal
      open={alvo !== null}
      onClose={onCancel}
      title="Excluir campanha"
      footer={
        <>
          <Button variant="ghost" onClick={onCancel}>
            Cancelar
          </Button>
          <Button variant="danger" icon="lixeira" onClick={onConfirm}>
            Excluir
          </Button>
        </>
      }
    >
      <p className="text-sm text-ink-muted">
        A campanha <span className="font-medium text-ink">"{alvo ?? ''}"</span> ainda não saiu e vai sair da lista. Nenhum e-mail foi enviado por ela.
      </p>
    </Modal>
  );
}
